import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavItem } from '@app/shared/models/menu.inteface';
import { AuthService } from '@services/auth.service';
import { Subscription } from 'rxjs';
import { MenuListItemComponent } from './menu-item/menu-list-item.component';
import { MenuActiveService } from './menu-active.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  menu!: NavItem[];
  subs!: Subscription;

  constructor(private authSvc: AuthService, public router: Router, private menuActiveSvc: MenuActiveService) {}

  ngOnInit(): void {
    this.subs = this.authSvc.isLogged$.subscribe((logged) => {
      if (logged) {
        this.authSvc.readMenu().subscribe((userMenu) => {
          this.menu = userMenu.Data;
          this.menuActiveSvc.setUris(this.flattenUris(this.menu));
        });
      }
    });
  }

  private flattenUris(items: NavItem[]): string[] {
    const uris: string[] = [];

    for (const item of items || []) {
      if (item.Uri) uris.push(item.Uri);
      if (item.Nodes?.length) uris.push(...this.flattenUris(item.Nodes));
    }

    return uris;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
